import { render, staticRenderFns } from "./RiskHeader.vue?vue&type=template&id=e185bb8e&scoped=true"
import script from "./RiskHeader.vue?vue&type=script&lang=js"
export * from "./RiskHeader.vue?vue&type=script&lang=js"
import style0 from "./RiskHeader.vue?vue&type=style&index=0&id=e185bb8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e185bb8e",
  null
  
)

export default component.exports